import { defineComponent as _defineComponent } from 'vue'
import type { MultiStepSportEvent, SportEventBucketsEdgeV2 } from '@/@types/graphql-types';

import SportHeader from '@/features/sports/components/ui/SportHeader.vue';
import EventCardOld from '@/features/sports/components/global/EventCardOld.vue';
import CompetitionLogo from '@/features/sports/components/ui/CompetitionLogo.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitionEventsItemOld',
  props: {
    competition: null,
    hideHeader: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	competition: SportEventBucketsEdgeV2;
	hideHeader?: boolean;
};



const sportType = computed(() => props.competition.node.edges?.[0].node.sport!);
const events = computed(() => {
	return (props.competition.node.edges ?? [])
		.map(edge => edge.node as MultiStepSportEvent)
		.filter(node => node.parent != null);
});

const parentCompetition = computed(() => {
	return props.competition.key.parent?.competition ?? props.competition.key.competition;
});

const fullPath = computed(() => parentCompetition.value?.content.fullPath);

const name = computed(() => parentCompetition.value?.content.name);

return { __sfc: true,props, sportType, events, parentCompetition, fullPath, name, SportHeader, EventCardOld, CompetitionLogo }
}

})